import React                      from 'react'
import { Observer }               from 'mobx-react'

import { TEXT }                   from '../00_assets'
import { kde_api_workgroup_t }    from '../02_api'
import { AddressEditor
       , address_form_fields
       , contact_form_fields
       , ContactEditor
       , FIELD_TYPE
       , FormError
       , FormField
       , form_model
       , IFormEditor
       , IFormEditorModel
       , VALID }  from '../10_ui'


export function create_workgroup_editor_model ( workgroup: kde_api_workgroup_t  )
{
  const fields =
    { name     : { label: TEXT.WORKGROUPS_NAME
                 , init: workgroup.name
                 , type: FIELD_TYPE.INPUT
                 , is_valid: VALID.non_empty_txt
                 , required: true
                 }
    , ...address_form_fields( workgroup.address )
    , ...contact_form_fields( workgroup.contact )
    } ;

  return form_model( fields
                   , ( data: IFormEditorModel ) =>
                      ({ name: data.name.value( )
                       , address: data.address.value( )
                       , contact: data.contact.value( )
                       })
                   ) ;
}


export const WorkgroupEditor: React.FC< { form: IFormEditor } > = ( { form } ) =>
<Observer render={ ( ) => 
{ 
  return <>
         <FormField field={ form.model.name    } />
         
         <ContactEditor form={ form } />

         <AddressEditor form={ form } />

         <FormError has={ form.show_error( ) } />
     </> ;
} } /> ;